import { last } from 'lodash'
import React from 'react'
import Manager from '../../public/components/Manager'
import PurchaseDiv from './PurchaseDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
        { _text: '采购单号', field: 'Number', minWidth: 150, search: true, flex: 1 },
        { _text: '采购项目', field: 'MaterialNames', renderer: o => o.join(','), search: true, sortable: false, minWidth: 150, flex: 1 },
        { _text: '供应商名称', field: 'Supplier', minWidth: 150, search: true, flex: 1 },
        { _text: '申请部门', field: '_CreateDep', minWidth: 150, flex: 1, },
        { _text: '状态名称', field: 'StatusName', minWidth: 150, search: true, flex: 1 },
        { _text: '签核人', field: '_Signatory', minWidth: 150, flex: 1 },
        { _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },

    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <PurchaseDiv {...props} id={data.id} onSave={refreshPage} readOnly={true} />)
    }

}

export default props => <Manager {...props} config={config} />